import { __spreadArray } from "tslib";
export var flattenCategories = function (cats) {
    return cats.reduce(function (p, c) {
        var children = c.children || [];
        var childrenFlats = children.reduce(function (sp, sc) {
            return __spreadArray([{ id: sc.id, name: sc.name, parentName: c.name, parentId: c.id }], sp, true);
        }, []);
        return __spreadArray(__spreadArray(__spreadArray([], p, true), [{ id: c.id, name: c.name }], false), childrenFlats, true);
    }, []);
};
export var flattenLeafCategories = function (cats) {
    return cats.reduce(function (leafCats, parentCategory) {
        if (parentCategory.children && parentCategory.children.length) {
            return __spreadArray(__spreadArray([], leafCats, true), parentCategory.children.map(function (childCategory) {
                return {
                    name: childCategory.name,
                    id: childCategory.id,
                    parentName: parentCategory.name,
                    parentId: parentCategory.id
                };
            }), true);
        }
        return __spreadArray(__spreadArray([], leafCats, true), [{
                id: parentCategory.id,
                name: parentCategory.name
            }], false);
    }, []);
};
//# sourceMappingURL=flatten-categories.js.map